module.exports = __webpack_public_path__ + "3a931444f0cca67787be31e72bb54f3e.svg";